import { usePersistedState } from '../lib/persistedState.ts';

/** The three steps, as a tuple so `TileSize` is the roster rather than
 *  `string` and the map below is exhaustive by construction. */
const SIZES = ['sm', 'md', 'lg'] as const;
export type TileSize = (typeof SIZES)[number];

const LABELS: Record<TileSize, string> = { sm: 'Small cards', md: 'Medium cards', lg: 'Large cards' };

/** Persisted S/M/L choice for a tile grid. The page maps the value to a
 *  pixel minimum and feeds it to the grid as the --tile-min CSS var. */
export function useTileSize(storageKey: string) {
  return usePersistedState<TileSize>(storageKey, 'md');
}

type TileSizeControlProps = {
  value: TileSize;
  onChange: (size: TileSize) => void;
};

/** Three-step card-size switch (small / medium / large squares). */
export default function TileSizeControl({ value, onChange }: TileSizeControlProps) {
  return (
    <span className="tile-size" role="group" aria-label="Card size">
      {SIZES.map((s) => (
        <button
          key={s}
          type="button"
          className={'tile-size__btn' + (value === s ? ' is-active' : '')}
          aria-pressed={value === s}
          title={LABELS[s]}
          aria-label={LABELS[s]}
          onClick={() => onChange(s)}
        >
          <span className={`tile-size__box tile-size__box--${s}`} aria-hidden="true" />
        </button>
      ))}
    </span>
  );
}
